import { configureStore } from '@reduxjs/toolkit'

import applicationReducer from '@/utils/store/features/application/applicationSlice'
import assistantsReducer from '@/utils/store/features/assistants/assistantsSlice'
import authenticationReducer from '@/utils/store/features/authentication/authenticationSlice'
import filterReducer from '@/utils/store/features/filter/filterSlice'

export type RootState = ReturnType<typeof store.getState>

const store = configureStore({
    reducer: {
        application: applicationReducer,
        assistants: assistantsReducer,
        authentication: authenticationReducer,
        filter: filterReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})

export default store
